import {type AlertColor} from '@mui/material';
import {
  type SnackbarMessage,
  useSnackbar as useNotistackSnackbar,
} from 'notistack';

type Return = (message: string, severity?: AlertColor) => void;

const useSnackbar = (): Return => {
  const {enqueueSnackbar} = useNotistackSnackbar();

  return (message: SnackbarMessage, severity: AlertColor = 'info'): void => {
    // In notistack v3 with Components approach, the variant is passed directly
    // to the component, so we just use the severity as the variant
    enqueueSnackbar(message, {
      variant: severity,
    });
  };
};

export default useSnackbar;
